export enum DocumentType {
  POLICIES_ACKNOWLEDGEMENTS = "policies-acknowledgements",
  DRIVERS_LICENSE = "drivers-license",
  SOCIAL_SECURITY = "social-security",
  STATE_LICENSE = "state-license",
  CERTIFICATIONS = "certifications",
  EMPLOYMENT_CONTRACT = "employment-contract",
  WORK_VISA = "work-visa",
  PHOTOS = "photos",
  CHECKINS = "checkins",
}
